import type { SuperEnhancementChatMessageResponseDto } from 'app/API/models';

export const getSuperEnhancementStageOptions = (messages: SuperEnhancementChatMessageResponseDto[]) =>
  messages.reduce(
    (options, message) => {
      if (message.role !== 'user') {
        return options;
      }
      switch (message.content) {
        case 'Enable speaker correction':
          return { ...options, speakerCorrection: true };
        case 'Disable speaker correction':
          return { ...options, speakerCorrection: false };
        case 'Enable audio relistening':
          return { ...options, audioRelistening: true };
        case 'Disable audio relistening':
          return { ...options, audioRelistening: false };
        case 'Enable edit verification':
          return { ...options, verifyEdits: true };
        case 'Disable edit verification':
          return { ...options, verifyEdits: false };
        default:
          return options;
      }
    },
    { speakerCorrection: true, audioRelistening: true, verifyEdits: true },
  );
